<template>
  <teleport to="body">
    <div ref="dropDown" id="drop-down-modal">
      <div id="modal-body">
        <div id="modal-content">
          <h1>Print Options</h1>
          <div id="btns-wrap">
            <button aria-label="Open print preview" @click="openPrintPreview">
              PRINT FROM HOME
            </button>
            <div id="spacer">
              <span></span>
              <p>OR</p>
              <span></span>
            </div>
            <button aria-label="Let us print" @click="saveAndContinue">
              LET US PRINT
            </button>
            <img id="drop-down-logo" src="@/assets/logo-sheetlabels-popup.svg" />
          </div>
          <p>
            Printing can be a pain! Forget the hassle, we'll do the heavy lifting! Save time and
            office supplies while getting professional quality.
          </p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "PrintOptions",
  emits: ["setPrintOptionsPosition", "saveAndContinue"],
  setup(_, { emit }) {
    const dropDown = ref<HTMLDivElement>();

    onMounted(() => {
      if (dropDown.value) {
        emit("setPrintOptionsPosition", dropDown.value);
      }
    });

    const openPrintPreview = () => {
      store.dispatch(ActionTypes.SET_MODAL, "printPreview");
    };

    const saveAndContinue = () => {
      emit("saveAndContinue");
    };

    return { dropDown, openPrintPreview, saveAndContinue };
  },
});
</script>

<style scoped>
#drop-down-modal {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 350px;
  height: 350px;
  border-radius: 4px;
  z-index: 2;
  box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
  font-size: 18px;
}

#modal-body {
  width: 90%;
  height: 90%;
}

#modal-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

#modal-content h1 {
  width: 100%;
}

#btns-wrap {
  width: 100%;
  height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

#btns-wrap button {
  display: block;
  height: 40px;
  padding: 0 2px 0 2px;
  width: 100%;
  background: #00af43;
  color: #fff;
  font-size: 16px;
  text-transform: uppercase;
  word-spacing: 5px;
  border: none;
  border-radius: 4px;
}

#btns-wrap button:hover {
  background-color: #fff;
  color: #00af43;
  border: 1px solid #00af43;
  cursor: pointer;
  transition: background-color 0.25s, color 0.25s, border 0.25s;
}

#spacer {
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

#spacer span {
  background-color: #aaa;
  width: 45%;
  height: 1px;
}

#drop-down-logo {
  width: 60%;
}

#modal-body p {
  font-size: 14px;
}
</style>
